/**
 * Barres de stat « duo » [domicile, extérieur], partagées par le panneau de
 * match au survol (préfixe `.mp-*`) et la grande carte « En direct »
 * (préfixe `.lf-st-*`). Le préfixe de classe est paramétrable pour que chaque
 * hôte conserve son propre style tout en partageant la logique de rendu.
 */
import { esc } from "../html.ts";

/**
 * Formate une valeur de stat : "—" si absente, "74%" en pourcentage, "2.15"
 * pour un décimal (xG…), "24" pour un entier (tirs, corners…).
 */
export function fmtStat(v: number | null | undefined, asPct = false): string {
  if (v == null) return "—";
  if (asPct) return `${Math.round(v)}%`;
  return Number.isInteger(v) ? `${v}` : v.toFixed(2);
}

/**
 * Une stat réelle [domicile, extérieur] : en-tête (valeur · libellé · valeur)
 * au-dessus d'une barre duo proportionnelle au partage domicile/extérieur.
 * Chaîne vide si la paire est absente (les deux valeurs nulles). `cls` = préfixe
 * de classe ("mp" pour le panneau de match, "lf-st" pour la carte live). `key`,
 * s'il est fourni, marque la ligne (`data-stat`) pour le graphe d'évolution au
 * survol (voir statGraphTip).
 */
export function duoStat(
  label: string,
  pair: readonly [number | null, number | null] | undefined,
  asPct = false,
  cls = "mp",
  key?: string,
): string {
  if (!pair || (pair[0] == null && pair[1] == null)) return "";
  const total = (pair[0] ?? 0) + (pair[1] ?? 0);
  const share = total > 0 ? (pair[0] ?? 0) / total : 0.5;
  const h = Math.max(2, Math.min(98, Math.round(share * 100)));
  const tag = key ? ` data-stat="${esc(key)}"` : "";
  return `<div class="${cls}-sec"${tag}><div class="${cls}-h"><span>${fmtStat(pair[0], asPct)}</span><span class="mid">${esc(
    label,
  )}</span><span>${fmtStat(pair[1], asPct)}</span></div><div class="${cls}-bar duo"><span class="h" style="width:${h}%"></span><span class="a" style="width:${100 - h}%"></span></div></div>`;
}
